import { render } from "./ChampionBuilds.vue?vue&type=template&id=71a6b4cd&scoped=true"
import script from "./ChampionBuilds.vue?vue&type=script&lang=ts"
export * from "./ChampionBuilds.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-71a6b4cd"

export default script